import Repository from "../../repository";

export default {
    Get: (payload) => Repository.post(`/api/WaterwayClearanceHeights/Get`, payload),
    GetActive: (payload) => Repository.post(`/api/WaterwayClearanceHeights/GetActive`, payload),
    GetById: (payload) => Repository.post(`/api/WaterwayClearanceHeights/GetById`, payload),
    Add: (payload) => Repository.post(`/api/WaterwayClearanceHeights/Add`, payload),
    Edit: (payload) => Repository.post(`/api/WaterwayClearanceHeights/Edit`, payload),
    Delete: (payload) => Repository.post(`/api/WaterwayClearanceHeights/Delete`, payload),
    ChangeStatus: (payload) => Repository.post(`/api/WaterwayClearanceHeights/ChangeStatus`, payload),
}
